module.exports = __webpack_public_path__ + "img/72.fd7ff4d7.png";